const TRIP_CHAT_STAFF_ACCESS_EMAILS = new Set([
  // Keep in sync with the backend permission allowlist in svc-trip/src/api/v3/utils/tripChatStaffAccess.ts.
  // Backend remains the permission boundary; this only controls whether the staff form is shown.
  'william.ritossa@luxuryescapes.com',
  'sarah.hierstaetter@luxuryescapes.com',
  'sam.hammond@luxuryescapes.com',
  'joshua.paling@luxuryescapes.com',
  'daniel.shar@luxuryescapes.com',
  'tan.nguyen@luxuryescapes.com',
  'ashok.elumalai@luxuryescapes.com',
  'amanda.tansi@luxuryescapes.com',
])

export function canAccessStaffChat(email?: string): boolean {
  if (!email) {
    return false
  }

  return TRIP_CHAT_STAFF_ACCESS_EMAILS.has(email.trim().toLowerCase())
}
